import { Injectable } from '@angular/core';

@Injectable()
export class CommonServiceService {

  constructor() { }
  getCurrentDate() : string {
    return new Date().toString();
  }
}



// WEBPACK FOOTER //
// ./src/app/component/common/common-service.service.ts